<template>
    <v-container fluid class="pa-0">

        <v-row justify="center">
            <v-dialog v-model="dialog" width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Términos y Condiciones</span>
                    </v-card-title>
                    <v-card-text style="text-align: justify;">
                        Al aceptar estos términos, autorizo expresamente a Southbridge Compañía de Seguros Generales
                        S.A. para que trate, almacene, transmita y comunique mis datos personales y la información que
                        he proporcionado voluntariamente, conforme a las finalidades y condiciones que se detallan a
                        continuación:
                        <br><br>
                        <span class="blackLetter">1. Finalidades del Tratamiento de Datos:</span>
                        <br><span class="blackLetter2">Ofrecimiento de Productos y Servicios:</span> Para que
                        Southbridge y las entidades relacionadas me contacten y me proporcionen información y ofertas de
                        sus productos y servicios.
                        <br><span class="blackLetter2">Ejecución del Contrato de Seguro:</span> Para gestionar y cumplir
                        con las obligaciones derivadas del contrato de seguro.
                        <br><span class="blackLetter2">Implementación de Convenios Asociados:</span> Para hacer
                        efectivos los convenios relacionados con los seguros que he contratado.
                        <br><br>
                        <span class="blackLetter">2. Comunicación de Datos a Terceros:</span>
                        <br>-Autorizo la comunicación de mis datos personales a la empresa matriz de Southbridge,
                        sociedades del grupo empresarial al que pertenece y terceros prestadores de servicios, ubicados
                        dentro o fuera de Chile, exclusivamente para las finalidades antes mencionadas.
                        <br>
                        <br>-Southbridge garantiza que dichos terceros cumplirán con las mismas obligaciones de
                        confidencialidad y seguridad en el tratamiento de mis datos personales.
                        <br><br>
                        <span class="blackLetter">3. Derechos del Titular de los Datos:</span>
                        <br>-Tengo derecho a acceder, rectificar, cancelar y oponerme al tratamiento de mis datos
                        personales, conforme a lo establecido en la Ley N° 21.719.
                        <br>
                        <br>-Puedo revocar esta autorización en cualquier momento, lo que no afectará la licitud del
                        tratamiento basado en el consentimiento previo a su retirada.
                        <br><br>
                        <span class="blackLetter">4. Medios de Comunicación:</span>
                        <br>- Acepto que cualquier información, comunicación, declaración o notificación que deba
                        efectuar Southbridge en virtud del presente contrato de seguros sea realizada a través de correo
                        electrónico u otros sistemas de transmisión o registro digital, garantizando la autenticidad e
                        integridad de las comunicaciones.
                        <br><br>
                        <span class="blackLetter">5. Responsabilidad sobre Credenciales de Acceso:</span>
                        <br>-Reconozco que cualquier transacción realizada en el sitio <a
                            href="https://southbridgeseguros.cl/" target="_blank"
                            rel="noopener noreferrer">www.southbridgeseguros.cl</a> con mi RUT y clave personal se
                        entenderá como realizada por mí.
                        <br>
                        <br>-Soy responsable del uso y seguridad de mi clave personal, y exonero a Southbridge de
                        cualquier responsabilidad por el uso indebido de la misma por parte de terceros.
                        <br><br>
                        <span class="blackLetter">6. Veracidad de la Información:</span>
                        <br>-Me comprometo a proporcionar información veraz y actualizada para la contratación del
                        seguro y el uso de las claves o códigos de acceso, liberando a Southbridge de responsabilidad
                        por cualquier mal uso que terceros hagan de la información entregada exclusivamente a mi
                        persona.
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="botonCondiciones" style="color: white;" elevation="0" text
                            @click="dialog = false">
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <br>
            </v-dialog>
        </v-row>

        <br>

        <Titulo></Titulo>

        <div :class="Vflex">
            <NavBar :step="6" :userData="userData"></NavBar>
        </div>
        <br>

        <div v-show="showTokuIframe">

            <div id="toku-container">

            </div>

        </div>

        <div v-if="loadingToku == true" class="text-center" style="margin-top:5%">
            <!-- <div v-if="loadingFinal == true" class="text-center" style="margin-top:5%"> -->

            <v-progress-circular :size="300" color="primary" indeterminate></v-progress-circular>

            <br>
            <br>

            {{ cont }}

        </div>

        <div v-if="loadingToku == false">

            <br v-if="screen > 800">
            <br v-if="screen > 800">
            <br v-if="screen > 800">
            <br v-if="screen > 800">
            <br v-if="screen < 800">

            <div v-if="!showTokuIframe" style="margin: auto; margin-top: -7%;">

                <h3 class="text-center labelPaso">
                    ¡{{ capitalizeName(userData.name) }}, revisa tus datos!
                </h3>

                <br>

                <h4 :class="labelSubpaso" class="text-center">
                    Antes de contratar te mostramos un resumen de tu Seguro Oncológico IRAM
                </h4>

                <br><br>
                <v-row style="display: flex; justify-content: center; align-items: flex-start;">
                    <v-co>
                        <div :class="summaryMainContainer">
                            <v-card :elevation="hover ? 16 : 2" class="card-container"
                                style="  border:rgba(226, 226, 226, 1) 1px solid;" max-width="100%">
                                <v-card-text
                                    class=" font-weight-medium mt-12 text-center text-subtitle-1 color:primary">
                                </v-card-text>
                                <label :class="titleSummary">Resumen de tu póliza </label>
                                <hr class="hrline">
                                <v-col style="width: 100%; max-width: 100% !important;">


                                    <label class="labelEtiquetaResumen">Contratante: </label>

                                    <label class="labelEtiqueta">{{ userData.name }} {{ userData.surname }}</label>

                                    <br>

                                    <label class="labelEtiquetaResumen">Rut: </label>

                                    <label class="labelEtiqueta">{{ userData.rut }}</label>

                                    <br>

                                    <label class="labelEtiquetaResumen">Teléfono: </label>

                                    <label class="labelEtiqueta">{{ userData.phoneNumber }}</label>
                                    <br>

                                    <label class="labelEtiquetaResumen">Email: </label>

                                    <label class="labelEtiqueta">{{ userData.email }}</label>

                                    <br>

                                    <label class="labelEtiquetaResumen">Tipo de plan: </label>
                                    <label v-if="this.planData.plan.cantBenf.includes('familiar')"
                                        class="labelEtiqueta">Familiar</label>
                                    <label v-else class="labelEtiqueta">Individual</label>

                                    <div v-if="this.planData.plan.cantBenf.includes('familiar')">
                                        <div v-for="(benef, index) in benefData" :key="index">
                                            <label class="labelEtiquetaResumen">Carga Familiar: </label>

                                            <label class="labelEtiqueta">{{ benef.name }} {{ benef.surname }}</label>
                                        </div>
                                    </div>

                                    <br>
                                    <br>

                                    <div v-if="screen > 800" class="planSubShield">
                                        <img :src=iconSand alt="Protecciones" class="imgSand">
                                        <p class="planSubShieldDetalle">Este seguro tiene un tiempo de espera de
                                            activación <br> de 30 días contínuos desde la fecha de contratación.</p>
                                    </div>

                                    <div v-if="screen < 800" class="planSubShieldMobile">
                                        <img :src=iconSand alt="Protecciones" class="imgSand">
                                        <p class="planSubShieldDetalleMobile">Este seguro tiene un tiempo de espera de
                                            activación de 30 días contínuos desde la fecha de contratación.</p>
                                    </div>

                                    <br>


                                </v-col>

                                <div v-if="planData.setDesc" :class="descLabelPrice">
                                    <label> Antes <span style="text-decoration: line-through;">{{
                                        formatPrice(planData.planOutDesc) }}</span></label>
                                </div>
                                <br v-if="screen < 800">

                                <div>
                                    <div :class="rectangulo" style="text-align:center; ">
                                        <v-row :class="priceContain" style="align-items: center;">
                                            <div :class=labelPrecioPlan>Total a pagar: {{ formatPrice(this.planData.plan.values[0].priceCLP) }}
                                            </div>
                                            <div :class=labelPrecioUf>/ UF {{ (planData.plan.price).toFixed(2) }} mensual</div>
                                        </v-row>
                                    </div>
                                    <br>
                                </div>
                            </v-card>




                        </div>
                        <h3 :class="labelFecha">*De acuerdo al valor UF del día {{ fechaActual }}</h3>
                    </v-co>

                    <br v-if="screen < 800">
                    <br v-if="screen < 800">

                    <div :class="cuponConteiner">
                        <v-col>
                            <v-row
                                style="display: flex; align-items: flex-start; padding: 10px; justify-content: center;">
                                <img :src="iconSand" alt="Protecciones" class="imgSand" style="margin-right: 10px;">
                                <p style="color: #2D387C; font-weight: 600;">¿Tienes un cupón de descuento?</p>
                            </v-row>
                            <hr class="hrline" style="width: 100%;"><br>
                            <v-text-field :class="labelDescuento" v-model="planData.couponId" :rules="couponRules"
                                label="" maxlength="51" solo @keyup.enter="SendCouponID">
                            </v-text-field>
                            <p style="color: #4F74E3; font-weight: 600; cursor: pointer;" @click="SendCouponID">Aplicar
                                cupón</p>
                        </v-col>

                        <div v-if="planData.setDesc" :class="labeltextDesc">
                            <label class="descText"> &nbsp;&nbsp; ¡Descuento del {{ this.planData.valueDesc }}%
                                aplicado!</label>
                        </div>

                        <br v-if="invalidCoupon">
                        <div v-if="invalidCoupon" :class="labeltextInvalid"
                            style="display: flex; justify-content: center; flex-direction: wrap; margin-top: -6%;">
                            <label class="descTextInvalid" style="display: flex; flex-direction: nowrap;"> Cupón
                                inválido</label>
                        </div>

                    </div>

                </v-row>

                <br>

                <v-form ref="form" v-model="valid" max-witdh="300px"
                    style="display: flex; justify-content: center; margin-right: 20%;">

                    <v-hover>
                        <v-checkbox :class="vista" :rules="conditionsRules" :color="stepperColor" required>
                            <template v-slot:label>
                                <p :class="terminos">Acepto los
                                    <b>
                                        <a style="color:#2D387C" @click="dialog = true">términos y
                                            condiciones de privacidad</a>
                                    </b>
                                </p>
                            </template>
                        </v-checkbox>
                    </v-hover>
                </v-form>

                <br v-if="screen < 800">
                <br v-if="screen < 800">


                <div :class="buttonContainer">
                    <div class="button-container">
                        <div :class="summaryContainerResumen">
                            <div v-if="screen < 800"
                                style="display: flex;color: white;padding-top: 2%;padding-left: 2%;">
                                <div style="display: flex;height: 31px;width: 100%;">
                                    <img :src="shieldIconMobile" alt="shieldIcon" class="iconMobile">
                                    <div style="display: block;">
                                        <p class="iconTitle">Tipo de plan:</p>
                                        <p class="iconSubtitle">{{ userData.typePlan }}</p>
                                    </div>
                                </div>
                                <div style="display: flex;height: 31px;width: 100%;">
                                    <img :src="clockIconMobile" alt="clockIcon" class="iconMobile">
                                    <div style="display: block;">
                                        <p class="iconTitle">Activación:</p>
                                        <p class="iconSubtitle">En 30 días continuos</p>
                                    </div>
                                </div>
                                <div style="display: flex;height: 31px;width: 100%;">
                                    <img :src="cashIconMobile" alt="cashIcon" class="iconMobile">
                                    <div style="display: block;">
                                        <p class="iconTitle">Prima mensual:</p>
                                        <p class="iconSubtitle">{{ planData.plan.values[0].priceString }}</p>
                                    </div>
                                </div>
                            </div>
                            <br><br>
                            <div v-if="screen < 800" style="width: 100%; display: flex;">
                                <v-btn
                                    style="background-color: #4F74E3 !important; color: white; display: flex; justify-content: center;"
                                    @click="validate()" block>
                                    Continuar
                                </v-btn>
                            </div>


                        </div>


                        <div v-if="screen > 800"
                            style="position: fixed; bottom: 0; left: 0; width: 100%; z-index: 9999;">
                            <div class="cta-bar">
                                <div class="cta-item">
                                    <div class="cta-content">
                                        <img :src=ticketFooter alt="ticketFooter">
                                        <div style="margin-left: 10px;">
                                            <div class="cta-label">Tipo de plan:</div>
                                            <div v-if="this.planData.plan.cantBenf.includes('familiar')"
                                                class="cta-value">
                                                Familiar</div>
                                            <div v-else class="cta-value">Individual</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="cta-item">
                                    <div class="cta-content">
                                        <img :src=watchFooter alt="watchFooter">
                                        <div style="margin-left: 10px;">
                                            <div class="cta-label">Activación:</div>
                                            <div class="cta-value">En 30 días continuos</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="cta-item">
                                    <div class="cta-content">
                                        <img :src=currencyFooter alt="currencyFooter">
                                        <div style="margin-left: 10px;">
                                            <div class="cta-label">Prima mensual:</div>
                                            <div class="cta-value">{{ formatPrice(planData.plan.values[0].priceCLP) }}
                                                (UF {{
                                                    (planData.plan.values[0].price).toFixed(2) }})</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="cta-item">
                                    <v-btn :class="btnContinue" style="background-color: #4F74E3 !important;"
                                        @click="validate()" block>
                                        Continuar
                                    </v-btn>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <br>
        </div>

    </v-container>
</template>

<script>
import ShieldService from "../services/shield.service.js";
import Titulo from "../components/Titulo.vue";
import NavBar from "@/components/NavBar.vue";
import iconSand from "../assets/images/cuponIcon.svg";

import CryptoJS from 'crypto-js';
import swal from 'sweetalert';

import clockIconMobile from "@/assets/images/clockIcon.svg";
import shieldIconMobile from "@/assets/images/shieldIcon.svg";
import cashIconMobile from "@/assets/images/cashIcon.svg";
import ticketFooter from "@/assets/images/ticketFooter.svg";
import watchFooter from "@/assets/images/watchFooter.svg";
import currencyFooter from "@/assets/images/currencyFooter.svg";

export default {
    data() {
        return {
            secretKey: process.env.VUE_APP_CRYPT,
            personId: '',
            Vflex: '',
            showTokuIframe: false,
            toku: null,
            clockIconMobile,
            shieldIconMobile,
            cashIconMobile,
            ticketFooter,
            watchFooter,
            currencyFooter,
            terminos: null,
            dialog: false,
            name: "Test",
            fechaActual: null,
            cont: "Cargando.  ",
            loading: false,
            loadingToku: false,
            loadingFinal: false,
            loadingPlans: false,
            screen: window.screen.width,
            formatter: new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
            }),
            stepperColor: '#4F74E3',
            stepId: null,
            iconSand,
            edadMayor: null,
            plansReal: [],
            labelSubpaso: null,
            summaryMainContainer: null,
            titleSummary: null,
            labelFecha: null,
            btnCoupon: null,
            buttonContainer: null,
            summaryContainerResumen: null,
            btnContinue: null,
            planPrice: null,
            planPriceUf: null,
            userData: {
                name: null,
                surname: null,
                serialNumber: null,
                rut: null,
                typeIsapre: null,
                region: null,
                commune: null,
                comuneCode: null,
                regionCode: null,
                address: null,
                email: null,
                phoneNumber: null,
                couponId: null,
                stepId: null,
                old: null,
                dates: null,
                salud: null,
                questionOne: null,
                questionTwo: null,
                questionThree: null,
                typePlan: null,
                addressNumber: null,
                addressDepto: null,
                sonExist: false,
                arrayTypesBenef: [],
                oldAux: null,
                day: null,
                month: null,
                year: null,
            },
            servicesData: {
                stepId: null,
                contactID: null,
                type: 'create',
            },
            planData: {
                planOutDesc: null,
                setDesc: false,
                valueDesc: 0,
                couponId: null,
                plan: null,
            },
            benefData: [
                {
                    validRut: false,
                    tipo: null,
                    edad: null,
                    name: '',
                    surname: '',
                    rut: '',
                    days: ['Selecciona el mes'],
                    months: null,
                    years: null,
                    date: null,
                    newRut: '',
                    panel: 0,
                    year: null,
                    month: null,
                    day: null,
                }
            ],
            sonExist: false,
            activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
            conditionsRules: [
                (v) => !!v || "Debe estar de acuerdo con los términos y condiciones",
            ],
            couponRules: [
                (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres",
                (v) => !!v || 'El código de descuento es requerido.',
                (v) => (v && !/\s/.test(v)) || 'El código de descuento no puede contener espacios en blanco.',
                (v) => /^[a-zA-Z0-9]*$/.test(v) || 'Solo se permiten letras y números',
            ],
        }
    },
    components: { Titulo, NavBar },
    async mounted() {

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        document.body.setAttribute('data-sku', 'ONC-005-RSM');

        const query = this.$route.query;

        if (query.stepID) {

            const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

            this.userData = abandoned.userData;
            this.servicesData.stepId = abandoned._id;
            this.servicesData.type = 'update';
            this.planData = abandoned.planData;

            if (abandoned.benefData) {
                this.benefData = abandoned.benefData;
            }

            const userDataLocal = JSON.stringify(this.userData);
            const servicesDataLocal = JSON.stringify(this.servicesData);
            const planDataLocal = JSON.stringify(this.planData);
            const benefDataLocal = JSON.stringify(this.benefData);

            const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
            const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
            const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
            const encryptedBenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();

            sessionStorage.setItem('userData', encryptedUserDataLocal);
            sessionStorage.setItem('servicesData', encryptedServicesDataLocal);
            sessionStorage.setItem('planData', encryptedPlanDataLocal);
            sessionStorage.setItem('benefData', encryptedBenefDataLocal)

        } else {

            const userDataAux = sessionStorage.getItem('userData');
            const benefDataAux = sessionStorage.getItem('benefData');
            const servicesDataAux = sessionStorage.getItem('servicesData');
            const planDataAux = sessionStorage.getItem('planData');

            const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
            const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
            this.userData = JSON.parse(decryptedDataUser);
            // console.log("userData: ", this.userData);

            if (benefDataAux) {
                const bytesBenefData = CryptoJS.AES.decrypt(benefDataAux, this.secretKey);
                const decryptedDataPet = bytesBenefData.toString(CryptoJS.enc.Utf8);
                this.benefData = JSON.parse(decryptedDataPet);
                // console.log("benefData: ", this.benefData);
            }

            const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
            const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
            this.servicesData = JSON.parse(decryptedServicesData);
            // console.log("servicesData: ", this.servicesData);

            const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
            const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
            this.planData = JSON.parse(decryptedDataPlan);
            // console.log("planData: ", this.planData);

            if(this.planData.setDesc) {
                this.SendCouponID();
            }

            this.planPrice = this.planData.plan.values[0].priceCLP
            this.planPriceUf = this.planData.plan.price

        }

        if (this.activeCampaingUse == 'TRUE') {
            await ShieldService.updateContactActiveCampain(null, null, this.servicesData, 6);
        }

        this.calcularFecha()

        if (this.screen > 800) {
            this.vista = 'test';
            this.rectangulo = 'rectangulo';
            this.priceContain = 'priceContain';
            this.containBlock = 'containBlock';
            this.terminos = 'terminos';
            this.descLabelPrice = 'planOut';
            this.labelPrecioPlan = 'labelPrecioPlan';
            this.labelPrecioUf = 'labelPrecioUf';
            this.labelSubpaso = 'labelSubpaso';
            this.summaryMainContainer = 'summaryMainContainer';
            this.titleSummary = 'titleSummary';
            this.labelFecha = 'labelFecha';
            this.btnCoupon = 'btnCoupon';
            this.buttonContainer = 'buttonContainer';
            this.summaryContainerResumen = 'summaryContainerResumen';
            this.btnContinue = 'btnContinue';
            this.Vflex = 'VflexDesktop';
            this.cuponConteiner = 'cuponConteiner'
        } else {
            this.vista = 'test2';
            this.rectangulo = 'rectangulo2';
            this.priceContain = 'priceContain2';
            this.containBlock = 'containBlock2';
            this.labelPrecioPlan = 'labelPrecioPlan2';
            this.labelPrecioUf = 'labelPrecioUf2';
            this.terminos = 'terminos2';
            this.descLabelPrice = 'planOutMovil';
            this.labelSubpaso = 'labelSubpaso2';
            this.summaryMainContainer = 'summaryMainContainer2';
            this.titleSummary = 'titleSummary2';
            this.labelFecha = 'labelFecha2';
            this.btnCoupon = 'btnCoupon2';
            this.buttonContainer = 'buttonContainer2';
            this.summaryContainerResumen = 'summaryContainerResumen2';
            this.btnContinue = 'btnContinue2';
            this.Vflex = 'VflexMobile';
            this.cuponConteiner = 'cuponConteiner2'
        }
    },
    methods: {
        capitalizeName(name) {
            if (!name) return '';
            return name.charAt(0).toUpperCase() + name.slice(1);
        },
        calcularFecha() {
            let fecha = new Date().toISOString().substr(0, 10).split('-')
            this.fechaActual = fecha[2] + '/' + fecha[1] + '/' + fecha[0]
        },
        formatPrice(number) {
            return this.formatter.format(number);
        },
        back() {
            this.$emit("back");
        },
        async SendCouponID() {
            let couponId = this.planData.couponId.trim();

            let plansResponseIndividual = await ShieldService.getPlans(
                this.userData.old.name,
                this.userData.typePlan.toLowerCase(),
                couponId,
            );

            let plansResponseIndividualAux = await ShieldService.getPlans(
                this.userData.old.name,
                this.userData.typePlan.toLowerCase(),
                null,
            );

            if (plansResponseIndividual.status != 'error') {

                this.invalidCoupon = false;

                this.planData.valueDesc = Math.round(((Number(plansResponseIndividualAux[0].values[0].priceCLP) - Number(plansResponseIndividual[0].values[0].priceCLP)) / Number(plansResponseIndividualAux[0].values[0].priceCLP)) * 100);
                this.planData.planOutDesc = plansResponseIndividualAux[0].values[0].priceCLP;

                this.planPrice = plansResponseIndividual[0].values[0].priceCLP;
                this.planPriceUf = plansResponseIndividual[0].values[0].price;

                swal({
                    title: "¡Código válido!",
                    text: "El descuento se ha aplicado exitosamente.",
                    icon: "success",
                    button: "De acuerdo",
                });

                this.loadingPlans = false;
                this.planData.setDesc = true;
                this.planData.plan = plansResponseIndividual[0];

                const planDataLocal = JSON.stringify(this.planData);
                const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
                sessionStorage.setItem('planData', encryptedPlanDataLocal);

                this.$forceUpdate();

            } else {
                this.invalidCoupon = true;
                this.planData.couponId = null;
                this.planData.setDesc = false;
                this.planData.valueDesc = 0;

                swal({
                    title: "¡Código no válido!",
                    text: "¡Lamentablemente no existen planes asociados a este código de descuento. Intenta con otro código!",
                    icon: "info",
                    button: "Ok",
                });

            }
        },
        async validate() {

            if (this.$refs.form.validate()) {

                this.loadingToku = true;
                this.loading = true;
                this.loadingFinal = true;

                try {

                    if (this.activeCampaingUse == 'TRUE') {

                        await ShieldService.updateContactActiveCampain(null, null, this.servicesData, 'payment');
                    }

                    this.cont = "Estamos Procesando tu Solicitud . . ."

                    const res = await ShieldService.createInsurance(
                        this.userData,
                        this.benefData,
                        this.planData.plan,
                        this.servicesData.stepId,
                    );

                    window.location.href = res

                    this.loadingToku = false;

                } catch (error) {
                    this.loadingFinal = false;
                    this.loading = false;
                    this.$router.push({ path: '/og/error' })
                }
            }

        },
    }
}
</script>

<style lang="scss">
.card-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.card-body {
    flex: 1;
}

.card-footer {
    background: #4369e1;
    color: white;
    text-align: center;
    padding: 10px;
    border-radius: 0 0 10px 10px;
}

.VflexDesktop {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 50px;
    margin-top: -0.3%;
    margin-bottom: 2%;
}

.VflexMobile {
    background-color: rgb(247, 247, 247);
    display: flex;
    margin: auto;
    height: 30px;
    margin-top: -2.3%;
    margin-bottom: 2.3%
}

.buttonContainer2 {
    margin-bottom: 9%;
    margin-top: 7%;
}

.summaryContainerResumen2 {
    background-color: #2D387C;
    position: absolute;
    z-index: 1;
    width: 100%;
    margin-left: 0%;
    height: auto;
    padding-top: 3%;
    padding-bottom: 3%;
    margin-bottom: -12% !important;
}

.btnContinue {
    background-color: #2D387C !important;
    color: white;
    border-radius: 12px;
    width: 20%;
    height: 120%;
}

.btnContinue2 {
    background-color: #4F74E3 !important;
    color: white;
    border-radius: 12px;
    width: 70%;
    height: 120%;
}

.btnCoupon {
    background-color: #4F74E3;
    color: white;
    width: 80%;
    height: 50px;
}

.btnCoupon2 {
    background-color: none !important;
    box-shadow: none !important;
    color: #4F74E3 !important;
    width: 80%;
    height: 50px;
    font-weight: 700;
    margin-left: 8%;
}

.summaryMainContainer {
    margin: 1%;
    border: rgba(226, 226, 226, 1) 1px solid;
}

.summaryMainContainer2 {
    margin: 5%;
    width: 90%;
    margin-top: -4%;
    margin-right: 5%;
    margin-left: 5%;
}

.toku-frame {
    border: none;
}

.planOut {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-left: 38px;
}

.planOutDesc {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-left: 38px;
}

.planOutMovil {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #7474F4;
    margin-left: 38px;
    margin-top: -7%;
}

.planSubShield {
    background: #F3F3F3;
    border-radius: 4px;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;
    width: 80%;
    padding-left: 5%;
}

.planSubShieldMobile {
    background: #F3F3F3;
    border-radius: 4px;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;
    width: 80%;
    padding-left: 5%;
}

.planSubShieldDetalle {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    color: #2D387C;
    margin: auto;
    width: 310px;
    line-height: 193.34%;
    margin-top: 5%;
}

.planSubShieldDetalleMobile {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    color: #2D387C;
    margin: auto;
    width: 83%;
    margin-top: 5%;
    text-align: justify;
}

.labelFecha {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
    opacity: 0.75;
    margin: auto;
    text-align: center;
}

.labelFecha2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px !important;
    line-height: 16px;
    color: #232323;
    opacity: 0.75;
    margin: auto;
    text-align: center;
}

.labelPrecioPlan {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.02em;
    margin-right: 3px;
    color: #FFFF;
}

.labelPrecioUf {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #FFFF;
    opacity: 0.8;
}

.labelPrecioPlan2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    margin-right: 3px;
    color: #FFFF;
}

.labelPrecioUf2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    margin-right: 3px;
    color: #FFFF;
}

.botonCondiciones {
    box-sizing: border-box;
    padding: 12px 24px;
    gap: 10px;
    background: #4F74E3;
    border: 2px solid #4F74E3;
    border-radius: 8px;
    margin-top: -6%;
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.02em;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: auto;
}

.labelPaso {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: -0.01em;
    color: #4F74E3;
}

.labelSubpaso {
    font-family: Poppins;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: #2D387C;
}

.labelSubpaso2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: #2D387C;
    width: 90%;
    margin: auto;
}

.labelEtiquetaResumen {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: -0.01em;
    color: black;
    padding-left: 4%;
}

.labelEtiqueta {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 25px;
    letter-spacing: -0.01em;
    color: black;
    opacity: 0.75;
}

.terminos {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
}

.terminos2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
}

.titleSummary {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    color: #2D387C;
    text-align: center;
    margin: auto;
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: -10%;
}

.titleSummary2 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    color: #2D387C;
    text-align: center;
    margin: auto;
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: -15%;
}

.hrline {
    width: 80%;
    border: 1px solid #E1E1E1;
    margin: auto;
    margin-top: 2%;
}

.test {
    margin-left: 25%;
    margin-top: 1%;
}

.test2 {
    margin-left: 15%;
    margin-top: 2%;
}

.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

.rectangulo {
    box-sizing: border-box;
    display: block ruby;
    height: 52px;
    width: 525px;
    border: 2px solid #2D387C1f;
    border-radius: 5px;
    margin-right: 10px;
    background: #4F74E3;
    border-radius: 0px 0px 6px 6px;
    margin-bottom: -5%;
}

.priceContain {
    display: ruby-base;
    margin-top: 2.5% !important;
}

.priceContain2 {
    display: flex !important;
    justify-content: center;
}

.containBlock {
    max-width: 100% !important;
    width: 100% !important;
    padding: 0 !important;
}

.containBlock2 {
    max-width: 96% !important;
    width: 97% !important;
    padding: 0 !important;
    margin: auto;
}

.linea {
    position: absolute;
    top: 80%;
    transform: translateY(-50%);
    border-top: 2px solid #2D387C1f;
    width: calc(24%);
    height: 0;
    background: #2D387C;
    opacity: 0.15;
}

.lineaIzquierda {
    left: 0;
    width: 122px;
}

.lineaDerecha {
    right: 0;
    width: 120px;
}

.rectangulo2 {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    border: 2px solid #2D387C1f;
    background-color: #4F74E3;
    border-radius: 0px 0px 5px 5px;
    margin-top: -3%;
    position: relative !important;
    margin-bottom: -8%;
    top: 75% !important;
}

.step-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
        font-weight: 500;
        text-align: center;
        color: #464e71;
        margin-bottom: 2rem;
    }

    h2 {
        font-weight: 500;
        color: #464e71;
        margin-bottom: 1rem;
    }

    p {
        text-align: center;
    }

    .back-container {
        width: 100%;
        align-items: flex-start;

        .back-button {


            &:hover {
                opacity: 1;
            }
        }
    }

    .button-container {
        text-align: center;
    }

    .forecast-selector {
        text-transform: uppercase;
        font-weight: 600;
        color: #464e71;
    }
}

.titleLabel {
    display: flex;
    text-align: flex-start;
    margin-bottom: 3%;
    color: #525252
}

.blackLetter {
    color: black;
    font-size: 16px;
}

.blackLetter2 {
    color: black;
    font-size: 15px;
}

.planSubShieldMobile {
    background: #F3F3F3;
    border-radius: 4px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-top: 8px;
    width: 90%;
    padding-left: 5%;
}

.terminos2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 143.34%;
    letter-spacing: -0.3px;
    color: #232323;
    opacity: 0.8;
    text-align: justify;
    margin-top: 5%;
    width: 80%;
}

.cta-bar {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    background: #2a3a86;
    color: #fff;
    border-radius: 6px;
}

.cta-item {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
}

.cta-content {
    display: flex;
    align-items: center;
}

.cta-label {
    font-size: 12px;
    line-height: 1;
    opacity: 0.85;
}

.cta-value {
    font-size: 12px;
}

.cuponConteiner {
    background: #FAFAFA;
    border-radius: 8px;
    margin-left: 10%;
    padding: 2%;
    width: 35%;
    padding-bottom: 1%;
}

.cuponConteiner2 {
    background: #FAFAFA;
    border-radius: 8px;
    margin-left: 5%;
    margin-right: 5%;
    padding: 2%;
    width: 100%;
    padding-bottom: 1%;
}
</style>
